import Suppliers from './SuppliersPage';

export default Suppliers;
